import ProgramDetail from "./ProgramDetail";

export default ProgramDetail;
